<template>
    <div>
        <p class="is-italic has-text-info">
            {{
                translate("audit_logs.template.competitorCallIncreased", false, [
                    context.eventRegistrationId,
                    context.calledCompetitorFirstName,
                    context.calledCompetitorLastName,
                    context.calledCompetitorAcademy,
                ])
            }}
        </p>
        <p>
            {{ translate("common.category") }}: <span class="has-text-weight-bold">{{ context.categoryName }}</span
            >, {{ translate("common.round") }}:
            <span class="has-text-weight-bold">
                <FightRoundName :round-name="context.fightRound" :bracket-level="context.bracketLevel" />
            </span>
            <template v-if="context.fightNumber">
                ,
                {{ translate("common.fight_number") }}:
                <span class="tag is-white">#{{ context.fightNumber }}</span>
            </template>
        </p>
        <p>
            {{ translate("common.competitors") }}:
            <span class="has-text-weight-bold">{{ context.firstCompetitorName }}</span>
            vs.
            <span class="has-text-weight-bold">{{ context.secondCompetitorName }}</span>
        </p>
        <p>
            {{ translate("audit_logs.call_count") }}:
            <span class="has-text-weight-bold">{{ context.callCount }}</span>
        </p>
    </div>
</template>

<script setup lang="ts">
    import { CompetitorCallIncreased } from "../../Api/auditLogsApi";
    import { translate } from "../../Common/translations";
    import { User } from "../../Common/types";
    import FightRoundName from "../../Common/FightRoundName.vue";

    defineProps<{
        context: CompetitorCallIncreased;
        user: User;
    }>();
</script>

<style scoped></style>
